<div class="graph--container">
  <div class="graph--left">
    <div class="graph-toolbar">
      <mat-slide-toggle
        [checked]="checked()"
        (change)="toggleChange($event)"
        color="primary"
        >Disable Zoom</mat-slide-toggle
      >
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="zoom_in"
        (buttonClicked)="zoomIn()"
        ariaLabel="Zoom in"
      ></app-mat-icon-button>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="zoom_out"
        (buttonClicked)="zoomOut()"
        ariaLabel="Zoom out"
      ></app-mat-icon-button>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="crop_free"
        (buttonClicked)="setDragMode('zoom')"
        ariaLabel="Box zoom"
        [buttonStyle]="dragMode() === 'zoom' ? 'selected' : 'grey'"
      ></app-mat-icon-button>
      <app-mat-icon-button
        iconName="pan_tool"
        (buttonClicked)="setDragMode('pan')"
        ariaLabel="Pan"
        [buttonStyle]="dragMode() === 'pan' ? 'selected' : 'grey'"
      ></app-mat-icon-button>
      <span class="toolbar-divider"></span>
      <app-mat-icon-button
        iconName="scatter_plot"
        (buttonClicked)="setGraphMode('markers')"
        ariaLabel="Scatter plot"
        [buttonStyle]="graphMode() === 'markers' ? 'selected' : 'grey'"
      ></app-mat-icon-button>
      <app-mat-icon-button
        iconName="show_chart"
        (buttonClicked)="setGraphMode('lines+markers')"
        ariaLabel="Line plot"
        [buttonStyle]="graphMode() === 'lines+markers' ? 'selected' : 'grey'"
      ></app-mat-icon-button>
      <span class="toolbar-divider"></span>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="download"
        (buttonClicked)="downloadImage()"
        ariaLabel="Download as PNG"
      ></app-mat-icon-button>
      <app-mat-icon-button
        buttonStyle="grey"
        iconName="refresh"
        (buttonClicked)="resetZoom()"
        ariaLabel="Auto scale"
      ></app-mat-icon-button>
    </div>
    @if (errorMessage) {
      <div class="error--container">
        <p class="error">{{ errorMessage }}</p>
      </div>
    }
    <div #plotlyDiv [id]="graphId"></div>
    <!-- Custom Legend -->
    <div class="legend--container">
      <div class="custom-legend">
        @for (device of legendData(); track device.deviceId; let i = $index) {
          <div class="legend-row">
            <span class="legend-device-name">{{ device.deviceName }}</span>
            @for (
              flask of device.flasks;
              track flask.traceIndex;
              let j = $index
            ) {
              <span
                class="legend-item"
                [class.legend-item--hidden]="!flask.visible"
                (click)="toggleLegendItem(i, j)"
              >
                <span
                  class="legend-marker"
                  [style.background-color]="flask.colour"
                ></span>
                <span class="legend-label">{{ flask.name }}</span>
              </span>
            }
          </div>
        }
      </div>
    </div>
  </div>
  <div class="graph--right">
    <div class="subtitle2">Advanced Settings</div>
    <div class="advanced--container">
      <app-underlined-form-field
        [field]="yMinRangeField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-form-field
        [field]="yMaxRangeField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-form-field
        [field]="xMinRangeField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-form-field
        [field]="xMaxRangeField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-form-field
        [field]="heightField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-form-field
        [field]="widthField()"
        [parentForm]="advancedSettingsForm()"
      >
      </app-underlined-form-field>
      <app-underlined-dropdown-form-field
        [parentForm]="advancedSettingsForm()"
        [field]="ratioField()"
      ></app-underlined-dropdown-form-field>
      <app-button
        buttonStyle="standard"
        label="Update"
        buttonId="range"
        (buttonClicked)="resizeGraph()"
        [isDisabled]="
          advancedSettingsForm().invalid || advancedSettingsForm().pristine
        "
      >
      </app-button>
    </div>
  </div>
</div>
